import { render, staticRenderFns } from "./LogoImage.vue?vue&type=template&id=8482dff0&scoped=true&"
import script from "./LogoImage.vue?vue&type=script&lang=js&"
export * from "./LogoImage.vue?vue&type=script&lang=js&"
import style0 from "./LogoImage.vue?vue&type=style&index=0&id=8482dff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8482dff0",
  null
  
)

export default component.exports